import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface DelayActivityTypeCategory extends BaseEntity {
  readonly description: string;
}
export type DelayActivityTypeCategoryCollection = RxCollection<DelayActivityTypeCategory> | null;
export type DelayActivityTypeCategoryDocument = RxDocument<DelayActivityTypeCategory>;

export const delayActivityTypeCategorySchema: RxJsonSchema<DelayActivityTypeCategory> = {
  type: 'object',
  version: 0,
  description: 'describes a DelayActivityTypeCategory object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    updatedAt: { type: 'number' },
    isDeleted: { type: 'boolean' },
    version: { type: 'number' },
  },
};

export const delayActivityTypeCategoryPullQueryBuilder = (doc: DelayActivityTypeCategory) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }

  const query = print(gql`
    query delayActivityTypeCategoryFeed($lastUpdateAt: Float!, $siteId: ID!, $limit: Int!) {
      delayActivityTypeCategoryFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
        version
        updatedAt
        isDeleted
        id
        description
      }
    }
  `);

  return {
    query,
    variables: {
      lastUpdateAt: doc.updatedAt,
      siteId: rootStore.user.siteId,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export const delayActivityTypeCategoryPushQueryBuilder = (doc: any) => {
  doc = doc[0];

  const query = print(gql`
    mutation CreateDelayActivityTypeCategory(
      $delayActivityTypeCategory: CreateDelayActivityTypeCategoryInput
    ) {
      createDelayActivityTypeCategory(input: $delayActivityTypeCategory)
    }
  `);

  const variables = {
    delayActivityTypeCategory: doc,
  };
  return {
    query,
    variables,
  };
};

export const delayActivityTypeCategoryPushModifier = (doc: DelayActivityTypeCategoryDocument) => {
  const obj = {
    ...doc,
  };

  const propertyBlackList = ['updatedAt', '_deleted', '_attachments', '_rev'];
  propertyBlackList.forEach(property => {
    obj[property] = undefined;
  });

  return obj;
};

export default {};
